import LocalizedLink from "@/components/LocalizedLink.vue";

export default {
    name: "Footer",
    props: {},
    data() {
      return {
          network: [
              {
                  id: "enel",
                  items: ["who_we_are", "our_offer", "stories", "contacts", "certifications"]
              },
              {
                  id: "commitment",
                  items: ["innovation_sustainability", "our_culture", "circular_economy"]
              },
              {
                  id: "media",
                  items: ["press_releases", "news", "events", "press_kit", "question_and_answers"]
              },
              {
                  id: "join",
                  items: ["job_openings", "global_partnership", "innovation_partner", "become_supplier"]
              },
              {
                  id: "ournetwork",
                  items: ["enel", "enelgreenpower", "openinnovability", "globalprocurement"]
              }
          ],
        partners: [
          {title:'footer.partnerThree.title', imgOne:'rina.png'}
        ],
        rights: ['footer.firstRight','footer.secondRight'],
        links: [
          {title:'footer.credits.title', route:'footer.credits.url'},
          {title:'footer.legal.title', route:'footer.legal.url'},
          {title:'footer.privacy.title', route:'footer.privacy.url'},
          {title:'footer.cookiePolicy.title', route:'footer.cookiePolicy.url'}
        ],
        social: [
          {img:'facebook.svg', alt:'Facebook', url:"https://www.facebook.com/enelxglobal"},
          {img:'youtube.svg', alt:'YouTube', url:"https://www.youtube.com/channel/UCAZ6GR88S1UbVE08amIl0cA/featured"},
          {img:'linkedin.svg', alt:'LinkedIn', url:"https://www.linkedin.com/company/enelx/?originalSubdomain=en"},
          {img:'twitter.svg', alt:'Twitter', url:"https://twitter.com/enelxglobal"},
          {img:'instagram.svg', alt:'Instagram', url:"https://www.instagram.com/enelxglobal/?hl=it"},
        ],
        cookieButton: {img:'cookiebutton.png', alt:'Cookie'}
      };
    },
    computed: {
      
    },
    components: {
      LocalizedLink
    },
    methods: {
    }

  };
